import React from 'react';
import './Start.css';

// This component represents a start button for a game
function StartGameButton() {

  // This function is called when the button is clicked
  function handleClick() {
    // It redirects the user to the '/game' URL
    window.location.href = '/game';
  }

  // This is the JSX code that will be rendered
  return (
    <div className="start-button">
      <h1 className='text-center'>Willkommen zum Spiel "BBiQ"!</h1>
      <button onClick={handleClick}>
        Spiel starten
      </button>
    </div>
  );
}

// Export the component
export default StartGameButton;
